import apiOffice from "../axios/apiOffice";

class ProceduresService {
  static async GetProceduresInPersonForMyAreas() {
    try {
      const response = await apiOffice.get(
        `/oficina/procedures/inPerson-per-areas`,
      );
      if (response.status < 400) {
        return { success: true, data: response.data };
      }
      return {
        success: false,
        message: "Unexpected response status",
        status: response.status,
      };
    } catch (error) {
      console.error("Error getting procedures:", error);
      return {
        success: false,
        message: error.message,
        status: error.response?.status || 500,
      };
    }
  }

  static async getProceduresByCategoryId(id) {
    try {
      const response = await apiOffice.get(
        `oficina/categories/category/procedure/${id}`,
      );
      if (response.status < 400) {
        return { success: true, data: response.data };
      }
      return {
        success: false,
        message: "Unexpected response status",
        status: response.status,
      };
    } catch (error) {
      console.error("Error getting procedures:", error);
      return {
        success: false,
        message: error.message,
        status: error.response?.status || 500,
      };
    }
  }

  static async getOptionsByProcedureId(id) {
    try {
      const response = await apiOffice.get(
        `oficina/procedures/procedure/option/${id}`,
      );
      if (response.status < 400) {
        return { success: true, data: response.data };
      }
      return {
        success: false,
        message: "Unexpected response status",
        status: response.status,
      };
    } catch (error) {
      console.error("Error getting procedures:", error);
      return {
        success: false,
        message: error.message,
        status: error.response?.status || 500,
      };
    }
  }

  static async getSubOptionsByOptionsId(id) {
    try {
      const response = await apiOffice.get(
        `oficina/procedures/option/subOption/${id}`,
      );
      if (response.status < 400) {
        return { success: true, data: response.data };
      }
      return {
        success: false,
        message: "Unexpected response status",
        status: response.status,
      };
    } catch (error) {
      console.error("Error getting procedures:", error);
      return {
        success: false,
        message: error.message,
        status: error.response?.status || 500,
      };
    }
  }

  static async getProcedureTemplate(procedure) {
    try {
      const body = {
        procedureId: parseInt(procedure),
      };
      const response = await apiOffice.post(
        `oficina/procedures/template`,
        body,
      );
      if (response.status < 400) {
        return { success: true, data: response.data };
      }
      return {
        success: false,
        message: "Unexpected response status",
        status: response.status,
      };
    } catch (error) {
      console.error("Error getting procedures:", error);
      return {
        success: false,
        message: error.message,
        status: error.response?.status || 500,
      };
    }
  }

  static async submitProcedure(body) {
    try {
      const response = await apiOffice.post(
        `oficina/procedures/submit-procedure`,
        body,
      );
      if (response.status < 400) {
        return { success: true, data: response.data };
      }
      return {
        success: response?.data?.message?.includes("CiDi") ? true : false,
        message: "Unexpected response status",
        status: response.status,
      };
    } catch (error) {
      console.error("Error getting procedures:", error);
      return {
        success: error.response?.data?.message?.includes("CiDi") ? true : false,
        message: error.response?.data?.message ?? error.message,
        status: error.response?.status || 500,
      };
    }
  }

  static async getDataSubmittedProcedure(id) {
    try {
      const response = await apiOffice.get(
        `oficina/procedures/submitted-procedure-data/${id}`,
      );
      if (response.status < 400) {
        return { success: true, data: response.data };
      }
      return {
        success: false,
        message: "Unexpected response status",
        status: response.status,
      };
    } catch (error) {
      console.error("Error getting procedures:", error);
      return {
        success: false,
        message: error.message,
        status: error.response?.status || 500,
      };
    }
  }

  static async GetProceduresAssignables(type = null) {
    try {
      const url = type 
        ? `/municipales/muni-procedures?type=${type}`
        : `/municipales/muni-procedures`;
      const response = await apiOffice.get(url);
      if (response.status < 400) {
        return { success: true, data: response.data };
      }
      return {
        success: false,
        message: "Unexpected response status",
        status: response.status,
      };
    } catch (error) {
      console.error("Error getting procedures:", error);
      return {
        success: false,
        message: error.message,
        status: error.response?.status || 500,
      };
    }
  }

  static async finishProcedure(id, message, urls = null) {
    try {
      const body = { message_communication: message, imageUrls: urls };
      const response = await apiOffice.put(
        `oficina/procedures/finish-procedure/${id}`,
        body,
      );
      if (response.status < 400) {
        return { success: true, data: response.data };
      }
      return {
        success: response?.data?.message?.includes("CiDi") ? true : false,
        message: "Unexpected response status",
        status: response.status,
      };
    } catch (error) {
      console.error("Error finish procedure:", error);
      return {
        success: error.response?.data?.message?.includes("CiDi") ? true : false,
        message: error.message,
        status: error.response?.status || 500,
      };
    }
  }

  static async filterProcedures(filters) {
    try {
      const body = { conditions: filters };
      const response = await apiOffice.post(
        `oficina/procedures/history/filter`,
        body,
      );
      if (response.status < 400) {
        return { success: true, data: response.data };
      }
      return {
        success: response?.data?.message?.includes("CiDi") ? true : false,
        message: "Unexpected response status",
        status: response.status,
      };
    } catch (error) {
      console.error("Error getting procedures:", error);
      return {
        success: error.response?.data?.message?.includes("CiDi") ? true : false,
        message: error.message,
        status: error.response?.status || 500,
      };
    }
  }

  static async getProceduresHistory() {
    try {
      const response = await apiOffice.get("/oficina/procedures/history");
      if (response.status < 400) {
        return { success: true, data: response.data };
      }
      return {
        success: response?.data?.message?.includes("CiDi") ? true : false,
        message: "Unexpected response status",
        status: response.status,
      };
    } catch (error) {
      console.error("Error getting procedures:", error);
      return {
        success: error.response?.data?.message?.includes("CiDi") ? true : false,
        message: error.message,
        status: error.response?.status || 500,
      };
    }
  }

  static async getChannels() {
    try {
      const response = await apiOffice.get(`/oficina/procedures/channels`);
      if (response.status < 400) {
        return { success: true, data: response.data };
      }
      return {
        success: false,
        message: "Unexpected response status",
        status: response.status,
      };
    } catch (error) {
      console.error("Error getting channels:", error);
      return {
        success: false,
        message: error.message,
        status: error.response?.status || 500,
      };
    }
  }

  static async changeProcedureMuni(procedureId, muniId) {
    try {
      const response = await apiOffice.put(
        `/oficina/procedures/change-muni/${procedureId}`,
        { muniId },
      );
      if (response.status < 400) {
        return { success: true, data: response.data };
      }
      return {
        success: response?.data?.message?.includes("CiDi") ? true : false,
        message: "Unexpected response status",
        status: response.status,
      };
    } catch (error) {
      console.error("Error finish procedure:", error);
      return {
        success: error.response?.data?.message?.includes("CiDi") ? true : false,
        message: error.message,
        status: error.response?.status || 500,
      };
    }
  }

  static async getProcedureDetailById(id) {
    try {
      const response = await apiOffice.get(`/oficina/procedures/history/${id}`);
      if (response.status < 400) {
        const data = response.data?.Procedure || response.data;

        return { success: true, data };
      }
      return {
        success: response?.data?.message?.includes("CiDi") ? true : false,
        message: "Unexpected response status",
        status: response.status,
      };
    } catch (error) {
      console.error("Error finish procedure:", error);
      return {
        success: error.response?.data?.message?.includes("CiDi") ? true : false,
        message: error.message,
        status: error.response?.status || 500,
      };
    }
  }

  static async updateStatus(procedureId, statusId) {
    try {
      const response = await apiOffice.put(
        `/oficina/procedures/procedure/update-status/${procedureId}`,
        {
          statusId,
        },
      );
      if (response.status < 400) {
        return { success: true, data: response.data };
      }
      return {
        success: response?.data?.message?.includes("CiDi") ? true : false,
        message: "Unexpected response status",
        status: response.status,
      };
    } catch (error) {
      console.error("Error getting procedures:", error);
      return {
        success: error.response?.data?.message?.includes("CiDi") ? true : false,
        message: error.message,
        status: error.response?.status || 500,
      };
    }
  }

  static async update(procedureId, body = null) {
    try {
      const response = await apiOffice.put(
        `/oficina/procedures/procedure/update/${procedureId}`,
        body,
      );
      if (response.status < 400) {
        return { success: true, data: response.data };
      }
      return {
        success: response?.data?.message?.includes("CiDi") ? true : false,
        message: "Unexpected response status",
        status: response.status,
      };
    } catch (error) {
      console.error("Error getting procedures:", error);
      return {
        success: error.response?.data?.message?.includes("CiDi") ? true : false,
        message: error.message,
        status: error.response?.status || 500,
      };
    }
  }

  static async updateUser(procedureId, userId) {
    try {
      const response = await apiOffice.put(
        `/oficina/procedures/procedure/update-user/${procedureId}`,
        {
          userId,
        },
      );
      if (response.status < 400) {
        return { success: true, data: response.data };
      }
      return {
        success: response?.data?.message?.includes("CiDi") ? true : false,
        message: "Unexpected response status",
        status: response.status,
      };
    } catch (error) {
      console.error("Error getting procedures:", error);
      return {
        success: error.response?.data?.message?.includes("CiDi") ? true : false,
        message: error.message,
        status: error.response?.status || 500,
      };
    }
  }

  static async updateAssignees(procedureId, body) {
    try {
      const response = await apiOffice.put(
        `/oficina/procedures/assignees/${procedureId}`,
        body,
      );
      if (response.status < 400) {
        return { success: true, data: response.data };
      }
      return {
        success: response?.data?.message?.includes("CiDi") ? true : false,
        message: "Unexpected response status",
        status: response.status,
      };
    } catch (error) {
      console.error("Error getting procedures:", error);
      return {
        success: error.response?.data?.message?.includes("CiDi") ? true : false,
        message: error.message,
        status: error.response?.status || 500,
      };
    }
  }

  static async searchByQuery(query) {
    try {
      const body = {
        query: query,
      };
      const response = await apiOffice.post(
        `oficina/procedures/search-procedures`,
        body,
      );
      if (response.status < 400) {
        return { success: true, data: response.data };
      }
      return {
        success: false,
        message: "Unexpected response status",
        status: response.status,
      };
    } catch (error) {
      console.error("Error getting procedures:", error);
      return {
        success: false,
        message: error.message,
        status: error.response?.status || 500,
      };
    }
  }

  static async getRenderedTemplateData(idHistory) {
    try {
      const response = await apiOffice.get(
        `oficina/procedures/history/${idHistory}/template`
      );
      if (response.status < 400) {
        return { success: true, data: response.data };
      }
      return {
        success: false,
        message: "Unexpected response status",
        status: response.status,
      };
    } catch (error) {
      console.error("Error getting rendered template data:", error);
      return {
        success: false,
        message: error.message,
        status: error.response?.status || 500,
      };
    }
  }



  static async getRelatedPdf(idHistory, data = {}) {
    try {
      const response = await apiOffice.post(
        `oficina/procedures/history/${idHistory}/generate-pdf`,
        data,
        {
          responseType: "blob",
        }
      );
      if (response.status < 400) {
        return { success: true, data: response.data };
      }
      return {
        success: false,
        message: "Unexpected response status",
        status: response.status,
      };
    } catch (error) {
      console.error("Error getting pdf:", error);
      return {
        success: false,
        message: error.message,
        status: error.response?.status || 500,
      };
    }
  }
}

export default ProceduresService;
